import React from 'react';
import { DEFAULT_LANGUAGE, type SupportedLanguage } from '../utils/language.utils';
import { useTranslation } from '../hooks/useTranslation';

export interface ModalFormFooterProps {
    language?: SupportedLanguage;
    saving?: boolean;
    formId?: string;
    onCancel: () => void;
    viewOnly?: boolean;
}

export const ModalFormFooter: React.FC<ModalFormFooterProps> = ({
    language = DEFAULT_LANGUAGE,
    saving = false,
    formId,
    onCancel,
    viewOnly = false,
}) => {
    const t = useTranslation(language);

    if (viewOnly) {
        return (
            <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
                disabled={saving}
            >
                {t.common.close}
            </button>
        );
    }

    return (
        <>
            <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
                disabled={saving}
            >
                {t.common.cancel}
            </button>
            <button
                type="submit"
                className="btn btn-primary"
                form={formId}
                disabled={saving}
            >
                {saving ? t.common.saving : t.common.save}
            </button>
        </>
    );
};
